import React from "react";

/** Placeholder heritage emblem — replace with Victor's Marine logo artwork when supplied. */
export function MarineEmblem({
  className = "",
  title
}: {
  className?: string;
  title?: string;
}) {
  return <svg viewBox="0 0 120 120" className={className} role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title} fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-59" data-mp="2o22ynz0y2w1l">
      <circle cx="60" cy="60" r="56" data-id="element-60" data-mp="2y23lvw1xpwb2" />
      <circle cx="60" cy="60" r="46" strokeDasharray="2 4" data-id="element-61" data-mp="2t1fmon3jy95r" />
      <path d="M60 28v58" data-id="element-62" data-mp="2t30jykh9467b" />
      <circle cx="60" cy="24" r="5" data-id="element-63" data-mp="370fda0amky4k" />
      <path d="M46 40h28" data-id="element-64" data-mp="36ze11shvi5l9" />
      <path d="M34 70c4 14 14 20 26 20s22-6 26-20" data-id="element-65" data-mp="36ykxt1i4hy7v" />
      <path d="M30 74l4-6 6 4M90 74l-4-6-6 4" data-id="element-66" data-mp="322njf0qf71xq" />
      <path d="M38 56l22-10 22 10" opacity="0.6" data-id="element-67" data-mp="31zhx1t96ee5p" />
      <text x="60" y="110" textAnchor="middle" fontSize="9" letterSpacing="3" fill="currentColor" stroke="none" fontFamily="Inter, sans-serif" data-id="element-68" data-mp="1cnpfh7h4z4rw">
        USMC
      </text>
    </svg>;
}